export const initialCompanyInfo = {
  company_name: "",
  logo: "",
  orgID: "",
  loading:false,
  tracking_page_details:null,
  showreport:""
};
